/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import can from 'can';
import BaseWidget from 'scripts/base-widget';
import 'components/viewing-schedule/viewing-schedule';

export const ViewingSchedule = BaseWidget.extend({
    init: function () {
        this.viewModel = {
            tabs: new can.List(this.options.tabs || []),
            backgroundImage: this.options.backgroundImage
        };
        this.view = can.stache('<viewing-schedule {tabs}="tabs" {background-image}="backgroundImage" />');
        this._super();
    }
});
